<template>
  <div
    class="cbg-white-container blog-listing-main input-container theme--light v-card border-card"
  >
    <div class="col-sm-12 row ml-0">
      <CCol sm="12" md="3">
        <label for>Search by name</label>
        <div class="position-relative search-div">
          <input 
            class="form-control" 
            placeholder="Search" 
            @input="debounceSearch()"
            v-model="search" />
          <div
            v-if="search !== ''"
            class="search-svg account-cross position-absolute"
            @click="clearSearch()"
          >
            <crossSVG />
          </div>
        </div>
      </CCol>
      <CCol sm="12" md="3" class="datepicker">
        <label for>Date Range</label>
        <datepicker
          v-model="dateRange"
          @input="dateChange()"
          ref="datepicker"
          :model-config="datePickerConfig"
          :max-date="new Date()"
          is-range
          :masks="{ input: 'DD-MM-YYYY' }"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <input
              :value="
                !!inputValue.start && !!inputValue.end
                  ? inputValue.start + ' - ' + inputValue.end
                  : 'DD/MM/YYYY'
              "
              v-on="inputEvents.start"
              class="form-control position-relative"
              placeholder="DD-MM-YYYY"
            />
            <div 
              v-if="!!inputValue.start && !!inputValue.end"
              class="cross-svg"
              @click="resetActiveDate"
            >
            <crossSVG />
            </div>
          </template>
        </datepicker>
        <div class="calendarsvg userinputcalendar pos-a">
          <calendarSVG />
        </div>
      </CCol>
    </div>
    <div class="col-sm-12 row ml-0 mt-0 pt-0">
      <div class="col-sm-12 d-flex align-center justify-content-space-bet">
        <h4 class="my-0">All files</h4>
        <div class="upload-doc-div cursor" @click="openUploadDialog()">
          <div class="upload-icon-div mr-3">
            <v-icon>mdi-upload</v-icon>
          </div>
          <span>Upload file</span>
        </div>
      </div>
    </div>
    <loader v-if="showLoader"></loader>
    <div v-else class="col-sm-12 px-4">
      <table class="table">
        <thead>
          <tr class="table-success">
            <th scope="col">Title</th>
            <th scope="col">File Name</th>
            <th scope="col">Uploaded date</th>
            <th scope="col">Size</th>
            <th scope="col">File type</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody v-if="dataList.length">
          <tr v-for="(er, i) in dataList" :key="i">
            <td>{{er.title}}</td>
            <td>{{er.file_name}}</td>
            <td>{{dayjs(er.created_at).format("YYYY-MM-DD")}}</td>
            <td>{{er.file_size}} kb</td>
            <td>
              <div class="d-flex align-center">
                <div class="pa-2 border-radius reject btn-white mr-3">PDF</div>
                <span class="cursor successcolor" @click="openPDF(er)">View</span>
              </div>
            </td>
            <td class="action-div">
              <div>
                <CDropdown color="link" size="lg" :caret="false">
                  <template #toggler-content>
                    <verticalDotsSVG class="w-1" />
                  </template>
                  <CDropdownItem @click="copyLink(er._id)">Copy link</CDropdownItem>
                  <CDropdownItem @click="updateModel(er._id)">Edit</CDropdownItem>
                </CDropdown>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="10">
              <h2 class="text-center">No Data Found</h2>
            </td>
          </tr>
        </tbody>  
      </table>
      <pagination
        v-if="!isEmpty"
        class="mx-6"
        :currentPage="dataList.page"
        :recordPerPage="recordPerPage"
        :total="total"
        @changePage="changePage"
      />
    </div>
    <upload-document-file
      v-if="uploadDocumentFile"
      :uploadDocumentFile="uploadDocumentFile"
      :updateObject="updateObject"
      @close="closeModal()"
    />
    <v-dialog v-model="galleryModal" width="900" content-class="v-dialog-lg">
      <v-card class="min-height" id="pharmacyCard">
        <nav
          class="v-toolbar theme--dark primary"
          data-booted="true"
          style="margin-top: 0px; padding-right: 0px; padding-left: 0px; transform: translateY(0px);"
        >
          <div class="v-toolbar__content" style="height: 40px;">
            <div class="v-toolbar__title">PDF</div>
            <div class="spacer"></div>
            <button type="button" @click="galleryModal = false">
              <v-icon style="color:white">close</v-icon>
            </button>
          </div>
        </nav>
        <v-card-text style>
          <embed :src="pdfSrc" width="100%" height="800px" />
        </v-card-text>
        <v-card-actions>
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-12 flex-end">
                <v-btn class="btn btn-red-outline" @click="galleryModal = false"
                  >Close</v-btn
                >
                <!-- <v-btn class="btn btn-primary" type="button">Save</v-btn> -->
              </div>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
const loader = () => import("@/components/loader.vue");
import dayjs from "dayjs";
import formats from "@/formats.js";
import config from "@/config.js";
import debounce from "lodash/debounce";
import { pickSvg } from "@/views/SVG";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const uploadDocumentFile = () => import("@/views/documents/uploadDocumentFile");
export default {
  data() {
    return {
      galleryModal: false,
      pdfSrc: '',
      showLoader: false,
      uploadDocumentFile: false,
      search: '',
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      dateRange: {
        start: "",
        end: "",
      },
      currentPage: 1,
      recordPerPage: 10,
      total: 0,
      dataList: [],
      linkUrl: `${config.DOCSMART_URL}admin-doc`,
      dayjs,
      formats,
      updateObject: {
        title: '',
        attachment: '',
        to_update: false
      },
      isEmpty: true
    };
  },
  components: {
    pagination: () => import("@/views/common/Pagination"),
    ...pickSvg("crossSVG", "verticalDotsSVG"),
    Datepicker,
    uploadDocumentFile,
    loader
  },
  created() {
    this.getAdminDocumentListing();
  },
  methods: {
    openPDF(data) {
      this.pdfSrc = data.attachment
      this.galleryModal = true
    },
    openUploadDialog() {
      this.uploadDocumentFile = true;
    },
    debounceSearch: debounce(function() {
      this.getAdminDocumentListing();
    }, 500),
    dateChange() {
      this.getAdminDocumentListing();
    },
    clearSearch() {
      this.search = "";
      this.getAdminDocumentListing();
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getAdminDocumentListing();
    },
    resetActiveDate() {
      this.dateRange = { start: "", end: "" };
      this.getAdminDocumentListing();
    },
    getAdminDocumentListing() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        search: this.search,
        start_date: this.dateRange.start === ""
            ? ""
            : new Date(this.dateRange.start).toISOString(),
        end_date: this.dateRange.end === ""
            ? ""
            : new Date(this.dateRange.end).toISOString()
      };
      let url = `${config.BASE_URL}api/v2/admin/admin-document`;
      this.$http.get(url, { params }).then(response => {
        if (response.status)
          this.showLoader = false;
          this.dataList = response.body.data.list;
          this.total = response.body.data.count;
          if (response.body.data.list.length){
            this.isEmpty = false
          }else {
            this.isEmpty = true
          }
      })
    },
    copyLink(id) {
      navigator.clipboard.writeText(`${this.linkUrl}?doc_id=${id}`);
      this.$swal.fire({
        toast: true,
        html: "<p> <b>" + "Link Copied" + "</b></p>",
        showCancelButton: false,
        showConfirmButton: false,
        position: "bottom",
        customClass: "bottom-swal",
        timer: 6000
      });
    },
    closeModal() {
      this.uploadDocumentFile = false;
      this.updateObject = {};
      this.getAdminDocumentListing()
    },
    updateModel(id) {
      let url = `${config.BASE_URL}api/v2/admin/admin-document/${id}`;
      this.$http.get(url, {}).then(response => {
        if (response.status){
          this.updateObject = response.body.data;
          this.updateObject.to_update = true;
          this.uploadDocumentFile = true
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.upload-doc-div {
  background-color: #321fdb;
  padding: 12px 18px;
  border-radius: 5px;
  color: #fff;
  display: flex;
  align-items: center;
  .upload-icon-div {
    background-color: #fff;
    border-radius: 4px;
    .v-icon {
      color: #321fdb;
    }
  }
}
</style>
